<template>
  <div>
    <CTabs variant="pills" :vertical="{ navs: 'col-md-2', content: 'col-md-10' }">
      <CTab active title="ISO 9001">
        <CRow>
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">E.03 Δελτίο Εφαρμογής Διαδικασίας</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE03"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.32 Έκθεση Επιθεώρησης Ε.Π.Ε.</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE32"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">E.35.1 Έκθεση Επιθεώρησης ISO 9001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE35('/files/E_35_1.docx', 'E_35_1_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
            </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.39.1 Πλάνο & Σχέδιο Επιθεώρησης ISO 9001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE39('/files/Ε_39_1.docx', 'E_39_1_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
      </CTab>
      <CTab title="ISO 14001">
        <CRow>
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">E.03 Δελτίο Εφαρμογής Διαδικασίας</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE03"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.32 Έκθεση Επιθεώρησης Ε.Π.Ε.</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE32"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.35.2 Έκθεση Επιθεώρησης ISO 14001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE35('/files/Ε_35_2.docx', 'E_35_2_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.39.2 Πλάνο & Σχέδιο Επιθεώρησης ISO 14001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE39('/files/Ε_39_2.docx', 'E_39_2_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
      </CTab>
      <CTab title="ISO 39001">
        <CRow>
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">E.03 Δελτίο Εφαρμογής Διαδικασίας</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE03"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.32 Έκθεση Επιθεώρησης Ε.Π.Ε.</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE32"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.35.9 Έκθεση Επιθεώρησης ISO 39001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE35('/files/Ε_35_9.docx', 'E_35_9_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.39.9 Πλάνο & Σχέδιο Επιθεώρησης ISO 39001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE39('/files/Ε_39_9.docx', 'E_39_9_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
      </CTab>
      <CTab title="ISO 41001">
        <CRow>
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">E.03 Δελτίο Εφαρμογής Διαδικασίας</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE03"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.32 Έκθεση Επιθεώρησης Ε.Π.Ε.</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE32"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.35.12 Έκθεση Επιθεώρησης ISO 41001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE35('/files/Ε_35_12.docx', 'E_35_12_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
      </CTab>
      <CTab title="ISO 45001">
        <CRow>
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">E.03 Δελτίο Εφαρμογής Διαδικασίας</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE03"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.32 Έκθεση Επιθεώρησης Ε.Π.Ε.</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE32"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.35.3 Έκθεση Επιθεώρησης ISO 45001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE35('/files/Ε_35_3.docx', 'E_35_3_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.39.3 Πλάνο & Σχέδιο Επιθεώρησης ISO 45001</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE39('/files/Ε_39_3.docx', 'E_39_3_' + current_case.case_code + '.docx')"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
      </CTab>
      <CTab title="Αγγλικά">
        <CRow>
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">E.35.1 Audit Report For Quality Management System</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE351_EN"
              color="primary"
            >
              Λήψη
            </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">E.03 Procedure Implementation Document</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE03_EN"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol sm="9" class="align-self-center">
            <p class="mb-0">Ε.32 FPC Audit Report</p>
          </CCol>
          <CCol sm="3" class="text-center">
            <CButton
              @click="renderE32_EN"
              color="primary"
            >
              Λήψη
              </CButton>
          </CCol>
        </CRow>
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import moment from 'moment'

function nullGetter(part, scopeManager) {
    /*
        If the template is {#users}{name}{/} and a value is undefined on the
        name property :

        - part.value will be the string "name"
        - scopeManager.scopePath will be ["users"] (for nested loops, you would have multiple values in this array, for example one could have ["companies", "users"])
        - scopeManager.scopePathItem will be equal to the array [2] if
          this happens for the third user in the array.
        - part.module would be empty in this case, but it could be "loop",
          "rawxml", or or any other module name that you use.
    */

    if (!part.module) {
        // part.value contains the content of the tag, eg "name" in our example
        // By returning '{' and part.value and '}', it will actually do no replacement in reality. You could also return the empty string if you prefered.
        return '';
    }
    if (part.module === "rawxml") {
        return "";
    }
    return "";
}

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}

export default {
  name: 'PrintedForms',
  props: {
    current_case: Object
  },
  data () {
    return {
      name: 'John'
    }
  },
  methods: {
    renderFile(input, data, output) {
      let self = this;
      loadFile(input, function(
        error,
        content
      ) {
        if (error) {
          throw error;
        }
        var zip = new PizZip(content);
        var doc = new Docxtemplater(zip, {nullGetter: nullGetter});
        doc.setData(data);
        try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render();
        } catch (error) {
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a properties object containing all suberrors).
          function replaceErrors(key, value) {
            if (value instanceof Error) {
              return Object.getOwnPropertyNames(value).reduce(function(
                error,
                key
              ) {
                error[key] = value[key];
                return error;
              },
              {});
            }
            return value;
          }
          console.log(JSON.stringify({ error: error }, replaceErrors));

          if (error.properties && error.properties.errors instanceof Array) {
            const errorMessages = error.properties.errors
              .map(function(error) {
                return error.properties.explanation;
              })
              .join("\n");
            console.log("errorMessages", errorMessages);
            // errorMessages is a humanly readable message looking like this :
            // 'The tag beginning with "foobar" is unopened'
          }
          throw error;
        }
        var out = doc.getZip().generate({
          type: "blob",
          mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        }); //Output the document using Data-URI
        saveAs(out, output);
      });
    },

    renderE35(input, output) {
      var data = {
        date: moment().format('DD-MM-YYYY'),
        company_name: this.current_case.client.company,
        company_name_en: this.current_case.client.company_en,
        email: this.current_case.client.email_1,
        address: this.current_case.client.address,
        phone: this.current_case.client.phone_number_1,
        case_code: this.current_case.case_code,
        fax: this.current_case.client.fax,
        website: this.current_case.client.website,
        service: this.current_case.certification_field,
        ea: this.current_case.service_subcategories.map((t) => {return t.name;}).join(", ")
      };
      this.renderFile(input, data, output);
    },

    renderE351_EN() {
      var input = "/files/Ε_35_1_en.docx";
      var data = {
        date: moment().format('DD-MM-YYYY'),
        company_name: this.current_case.client.company_en,
        email: this.current_case.client.email_1,
        address: this.current_case.client.address,
        phone: this.current_case.client.phone_number_1,
        case_code: this.current_case.case_code,
        fax: this.current_case.client.fax,
        website: this.current_case.client.website,
        service: this.current_case.certification_field,
        ea: this.current_case.service_subcategories.map((t) => {return t.name;}).join(", ")
      };
      var output = "E_35_1_" + this.current_case.case_code + "_en.docx";
      this.renderFile(input, data, output);
    },

    renderE03() {
      var input = "/files/E_03.docx";
      var inspectors = this.current_case.inspectors.filter((item) => item.pivot.role_id == 2);
      var inspector_a = '';
      var inspector_b = '';
      if (inspectors.length > 0) {
        inspector_a = inspectors[0].name;
        if (inspectors.length > 1) {
          inspector_b = inspectors[1].name;
        }
      }
      var chief_inspector = this.current_case.inspectors.find((item) => item.pivot.role_id == 1);
      if (chief_inspector) {
        chief_inspector = chief_inspector.name;
      }
      var data = {
        date: moment().format('DD-MM-YYYY'),
        company_name: this.current_case.client.company,
        case_code: this.current_case.case_code,
        service: this.current_case.certification_field,
        chief_inspector: chief_inspector,
        inspector_a: inspector_a,
        inspector_b: inspector_b
      };
      var output = "E_03_" + this.current_case.case_code + ".docx";
      this.renderFile(input, data, output);
    },
    renderE03_EN() {
      var input = "/files/Ε_03_en.docx";
      var inspectors = this.current_case.inspectors.filter((item) => item.pivot.role_id == 2);
      var inspector_a = '';
      var inspector_b = '';
      if (inspectors.length > 0) {
        inspector_a = inspectors[0].name;
        if (inspectors.length > 1) {
          inspector_b = inspectors[1].name;
        }
      }
      var chief_inspector = this.current_case.inspectors.find((item) => item.pivot.role_id == 1);
      if (chief_inspector) {
        chief_inspector = chief_inspector.name;
      }
      var data = {
        date: moment().format('DD-MM-YYYY'),
        company_name: this.current_case.client.company_en,
        case_code: this.current_case.case_code,
        service: this.current_case.certification_field,
        chief_inspector: chief_inspector,
        inspector_a: inspector_a,
        inspector_b: inspector_b
      };
      var output = "E_03_" + this.current_case.case_code + "_en.docx";
      this.renderFile(input, data, output);
    },

    renderE32() {
      var input = "/files/Ε_32.docx";
      var data = {
        date: moment().format('DD-MM-YYYY'),
        company_name: this.current_case.client.company,
        email: this.current_case.client.email_1,
        address: this.current_case.client.address,
        phone: this.current_case.client.phone_number_1,
        case_code: this.current_case.case_code,
        fax: this.current_case.client.fax,
        website: this.current_case.client.website,
      };
      var output = "E_32_" + this.current_case.case_code + ".docx";
      this.renderFile(input, data, output);
    },

    renderE32_EN() {
      var input = "/files/Ε_32_en.docx";
      var data = {
        date: moment().format('DD-MM-YYYY'),
        company_name: this.current_case.client.company_en,
        email: this.current_case.client.email_1,
        address: this.current_case.client.address,
        phone: this.current_case.client.phone_number_1,
        case_code: this.current_case.case_code,
        fax: this.current_case.client.fax,
        website: this.current_case.client.website,
      };
      var output = "E_32_" + this.current_case.case_code + "_en.docx";
      this.renderFile(input, data, output);
    },

    renderE39(input, output) {
      var inspectors = this.current_case.inspectors.filter((item) => item.pivot.role_id == 2);
      var inspector_a = '';
      if (inspectors.length > 0) {
        inspector_a = inspectors[0].name;
      }
      var chief_inspector = this.current_case.inspectors.find((item) => item.pivot.role_id == 1);
      if (chief_inspector) {
        chief_inspector = chief_inspector.name;
      }
      var data = {
        date: moment().format('DD-MM-YYYY'),
        company_name: this.current_case.client.company,
        case_code: this.current_case.case_code,
        service: this.current_case.certification_field,
        chief_inspector: chief_inspector,
        inspector: inspector_a,
        next_visit: moment(this.current_case.next_visit, 'DD/MM/YYYY').format('DD-MM-YYYY')
      };
      this.renderFile(input, data, output);
    },
  },
}
</script>
